import { MgoTransactionBlockResponse } from '@mgonetwork/mango.js/client';

// todo: add more logic for deriving transaction label
export const getLabel = (transaction: MgoTransactionBlockResponse, currentAddress?: string) => {
	const isSender = transaction.transaction?.data.sender === currentAddress;
	// Rename to "Send" to Transaction
	return isSender ? 'Transaction' : 'Receive';
};
